import React from 'react';

const IconAddLine = ({ color, width, height }) => {
  return (
    <svg
      fill={color}
      height={height}
      width={width}
      viewBox="0 0 512 512"
    >
      <path d="M470.4 1.5l-304 96C153.1 101.7 144 114 144 128v264.6c-14.1-5.4-30.5-8.6-48-8.6-53 0-96 28.7-96 64s43 64 96 64 96-28.7 96-64V220.5l272-85.9v194c-14.1-5.4-30.5-8.6-48-8.6-53 0-96 28.7-96 64s43 64 96 64 96-28.7 96-64V32c0-21.7-21.1-37-41.6-30.5z" />
    </svg>
  );
};

export default IconAddLine;



// WEBPACK FOOTER //
// ./src/IconAddLine.js